import React from 'react'
import styled from 'styled-components';

import playIcon from 'images/track_guides/play_icon.svg';

const Wrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${playIcon}) no-repeat center content-box;
  padding: 48px;
  pointer-events: none;

  @media (max-width: 576px) {
    background-size: contain;
  }
`;

const VideoOverlay = () => (
  <Wrapper />
);

export default VideoOverlay;
